import { fetch } from '@utils/utils';

import * as T from '@modules/requests/_requestsTypes';
// import { requestsUrl } from '@modules/requests/requestsGrid';
const requestsUrl = '/metropolis/api/owa/employee/requests';

export const getRequest = ({ addError }) => async (id: string): Promise<T.Request> => {
  try {
    const response: any = await fetch(`${requestsUrl}/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Request = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const requestAction = async (id: string, url: string): Promise<boolean> => {
  try {
    const response: any = await fetch(`${requestsUrl}/${id}/${url}`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    return response.ok;
  } catch (err) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/modules/requests/_requestsActions.ts